import { render, staticRenderFns } from "./hook.vue?vue&type=template&id=de8b5afe&"
import script from "./hook.vue?vue&type=script&lang=js&"
export * from "./hook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de8b5afe')) {
      api.createRecord('de8b5afe', component.options)
    } else {
      api.reload('de8b5afe', component.options)
    }
    module.hot.accept("./hook.vue?vue&type=template&id=de8b5afe&", function () {
      api.rerender('de8b5afe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/form-template/hook.vue"
export default component.exports